import { inject, Injectable } from '@angular/core';
import { translations } from '@app/utils/translations';
import { KuiMessageService } from '@kone/ui';

@Injectable({
    providedIn: 'root',
})
export class CustomMessageService {
    private messageService = inject(KuiMessageService);

    success(message?: string, life?: number) {
        this.messageService.success(message ?? translations.global.success, life ?? 5000);
    }

    info(message?: string, life?: number) {
        this.messageService.info(message ?? translations.global.information, life ?? 5000);
    }

    error(message?: string, life?: number) {
        this.messageService.error(message ?? translations.global.success, life ?? 5000);
    }

    clear() {
        this.messageService.clear();
    }
}
